import { createSelector } from 'reselect';
import { dataFormatterUtils } from '../../../utils';

// Free Rounds Promotions
const getFreeRoundsPromotions = (state: any) => state.promotionsReducer.allFreeRoundCampaigns;
const getTotalFreeRoundsPromotionsAmount = (state: any) => state.promotionsReducer.allFreeRoundCampaignsTotal;

const getFreeRoundsCampaign = (state: any) => state.promotionsReducer.freeRoundsCampaignData;
const getFreeRoundsCampaignSummary = (state: any) => state.promotionsReducer.freeRoundsCampaignSummary;

const getFreeRoundsCampaignPlayers = (state: any) => state.promotionsReducer.freeRoundsCampaignPlayers;
const getFreeRoundsCampaignPlayersTotal = (state: any) =>
    state.promotionsReducer.freeRoundsCampaignPlayersTotal;

const getFreeRoundsCampaignGames = (state: any) => state.promotionsReducer.freeRoundsCampaignGames;
const getFreeRoundsCampaignGamesTotal = (state: any) =>
    state.promotionsReducer.freeRoundsCampaignGamesTotal;

// Awarded Promotions
const getAwardedPromotions = (state: any) => state.promotionsReducer.allAwardedCampaigns;
const getTotalAwardedPromotionsAmount = (state: any) =>
    state.promotionsReducer.allAwardedCampaignsTotal;

const getAwardedCampaign = (state: any) => state.promotionsReducer.awardedCampaignData;
const getAwardedCampaignSummary = (state: any) => state.promotionsReducer.awardedCampaignSummary;

const getAwardedCampaignPlayers = (state: any) => state.promotionsReducer.awardedCampaignPlayers;
const getAwardedCampaignPlayersTotal = (state: any) =>
    state.promotionsReducer.awardedCampaignPlayersTotal;

const getAwardedCampaignGames = (state: any) => state.promotionsReducer.awardedCampaignGames;
const getAwardedCampaignGamesTotal = (state: any) =>
    state.promotionsReducer.awardedCampaignGamesTotal;


//Shared
const getPromotionsLoadingState = (state: any) => state.promotionsReducer.isLoading;
const getPromotionsError = (state: any) => state.promotionsReducer.error;
const getShouldUpdateData = (state: any) => state.promotionsReducer.shouldUpdateData;
const getGamesByPrice = (state: any) => state.promotionsReducer.gamesByPrice;
const getGamesByPriceAreLoading = (state: any) => state.promotionsReducer.gamesByPriceAreLoading;
const getClonedCampaign = (state: any) => state.promotionsReducer.clonedCampaign;
const getClonedCampaignCsv = (state: any) => state.promotionsReducer.clonedCampaignCsv;
const getIsClonedCampaignLoading = (state: any) => state.promotionsReducer.isClonedCampaignLoading;
const getCampaignHasBeenCreated = (state: any) => state.promotionsReducer.campaignHasBeenCreated;
const getCreatePromotionLoading = (state: any) => state.promotionsReducer.getCreatePromotionLoading;
const getIsExportingPlayersCsv = (state: any) => state.promotionsReducer.isExportingPlayersCsv;
const getExportedPlayersCsv = (state: any) => state.promotionsReducer.csv;



// Free Rounds Promotions
export const getFreeRoundsPromotionsData = createSelector(
    getFreeRoundsPromotions,
    (state) => state && dataFormatterUtils.getFormattedData(state),
);
export const getTotalFreeRoundsPromotionsAmountData = createSelector(
    getTotalFreeRoundsPromotionsAmount,
    (state) => state,
);

export const getFreeRoundsCampaignData = createSelector(getFreeRoundsCampaign, (state) => state);
export const getFreeRoundsCampaignSummaryData = createSelector(getFreeRoundsCampaignSummary, (state) => state);

export const getFreeRoundsCampaignPlayersTotalData = createSelector(
    getFreeRoundsCampaignPlayersTotal,
    (state) => state,
);
export const getFreeRoundsCampaignPlayersData = createSelector(getFreeRoundsCampaignPlayers, (state) => state);

export const getFreeRoundsCampaignGamesData = createSelector(
    getFreeRoundsCampaignGames,
    (state) => state,
);
export const getFreeRoundsCampaignGamesTotalData = createSelector(
    getFreeRoundsCampaignGamesTotal,
    (state) => state,
);



// Awarded Promotions
export const getAwardedPromotionsData = createSelector(
    getAwardedPromotions,
    (state) => state && dataFormatterUtils.getFormattedData(state),
);
export const getTotalAwardedPromotionsAmountData = createSelector(
    getTotalAwardedPromotionsAmount,
    (state) => state,
);

export const getAwardedCampaignData = createSelector(getAwardedCampaign, (state) => state);
export const getAwardedCampaignSummaryData = createSelector(
    getAwardedCampaignSummary,
    (state) => state,
);

export const getAwardedCampaignPlayersTotalData = createSelector(
    getAwardedCampaignPlayersTotal,
    (state) => state,
);
export const getAwardedCampaignPlayersData = createSelector(
    getAwardedCampaignPlayers,
    (state) => state,
);

export const getAwardedCampaignGamesData = createSelector(
    getAwardedCampaignGames,
    (state) => state,
);
export const getAwardedCampaignGamesTotalData = createSelector(
    getAwardedCampaignGamesTotal,
    (state) => state,
);


//Shared
export const getPromotionsLoadingStateData = createSelector(
    getPromotionsLoadingState,
    (state) => state,
);
export const getPromotionsErrorData = createSelector(getPromotionsError, (state) => state);
export const shouldUpdateData = createSelector(getShouldUpdateData, (state) => state);
export const getGamesByPriceData = createSelector(getGamesByPrice, (state) => state);
export const getGamesByPriceAreLoadingData = createSelector(
    getGamesByPriceAreLoading,
    (state) => state,
);
export const getClonedCampaignData = createSelector(getClonedCampaign, (state) => state);
export const getClonedCampaignCsvData = createSelector(getClonedCampaignCsv, (state) => state);
export const getIsClonedCampaignLoadingData = createSelector(
    getIsClonedCampaignLoading,
    (state) => state,
);
export const campaignHasBeenCreatedData = createSelector(
    getCampaignHasBeenCreated,
    (state) => state,
);
export const createPromotionLoadingData = createSelector(
    getCreatePromotionLoading,
    (state) => state,
);
export const isExportingPlayersCsvData = createSelector(getIsExportingPlayersCsv, (state) => state);
export const getExportedPlayersCsvData = createSelector(getExportedPlayersCsv, (state) => state);